import React from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const SEOTab = ({ issue, setIssue, onSave }) => {
  const seo = issue.seo || {};
  const upd = (k, v) => setIssue((s) => ({ ...s, seo: { ...(s.seo || {}), [k]: v } }));
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
  const ogUrl = `${BACKEND_URL}/api/og/${issue.slug || "cohnect"}.png`;
  return (
    <div className="space-y-6">
      <Card className="p-6">
        <div className="kicker">Meta tags</div>
        <div className="mt-3 grid gap-3">
          <Input placeholder="Meta title" value={seo.meta_title || ""} onChange={(e) => upd("meta_title", e.target.value)} className="h-11" />
          <Textarea placeholder="Meta description" rows={2} value={seo.meta_description || ""} onChange={(e) => upd("meta_description", e.target.value)} />
        </div>
      </Card>
      <Card className="p-6">
        <div className="kicker">Open Graph</div>
        <div className="mt-3 grid gap-3">
          <Input placeholder="OG title" value={seo.og_title || ""} onChange={(e) => upd("og_title", e.target.value)} className="h-11" />
          <Textarea placeholder="OG description" rows={2} value={seo.og_description || ""} onChange={(e) => upd("og_description", e.target.value)} />
          <Input placeholder="OG image text" value={seo.og_image_text || ""} onChange={(e) => upd("og_image_text", e.target.value)} className="h-11" />
          <Input placeholder="OG image alt" value={seo.og_image_alt || ""} onChange={(e) => upd("og_image_alt", e.target.value)} className="h-11" />
        </div>
        <div className="mt-4">
          <div className="text-xs text-muted-foreground mb-2">OG image preview</div>
          <img src={ogUrl} alt="OG preview" className="w-full max-w-md rounded-lg border border-border" data-testid="og-image-preview" />
        </div>
      </Card>
      <div className="flex items-center justify-end">
        <Button onClick={onSave} className="bg-[color:var(--coh-ink)] text-white hover:bg-[color:var(--coh-ink-2)]">Save SEO</Button>
      </div>
    </div>
  );
};
